import constants from '../contants';

export const getBaseUrl = () => {
	return `${constants.WP2_API_HOST}/inventory`;
};
